import React from 'react';

export default function SkeletonLoader({ type = 'table', rows = 5 }) {
    if (type === 'table') {
        return (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1px', background: 'var(--border)' }}>
                {Array.from({ length: rows }).map((_, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', height: '64px', background: 'var(--bg-surface)', padding: '0 24px', gap: '24px' }}>
                        <div className="skeleton-shimmer" style={{ width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0 }} />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                            <div className="skeleton-shimmer" style={{ width: '30%', height: '14px', borderRadius: '4px' }} />
                            <div className="skeleton-shimmer" style={{ width: '20%', height: '12px', borderRadius: '4px' }} />
                        </div>
                        <div className="skeleton-shimmer" style={{ width: '15%', height: '24px', borderRadius: '100px', flexShrink: 0 }} />
                        <div className="skeleton-shimmer" style={{ width: '10%', height: '14px', borderRadius: '4px', flexShrink: 0 }} />
                    </div>
                ))}
                <style>{`
                    .skeleton-shimmer {
                        background: linear-gradient(90deg, var(--bg-muted) 25%, var(--bg-subtle) 50%, var(--bg-muted) 75%);
                        background-size: 400% 100%;
                        animation: shimmer 1.5s infinite ease-in-out;
                    }
                    @keyframes shimmer {
                        0% { background-position: 200% 0; }
                        100% { background-position: -200% 0; }
                    }
                `}</style>
            </div>
        );
    }

    if (type === 'list') {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' }}>
                {Array.from({ length: rows }).map((_, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div className="skeleton-shimmer" style={{ width: '40px', height: '40px', borderRadius: '8px', flexShrink: 0 }} />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                            <div className="skeleton-shimmer" style={{ width: '40%', height: '14px', borderRadius: '4px' }} />
                            <div className="skeleton-shimmer" style={{ width: '60%', height: '12px', borderRadius: '4px' }} />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return null;
}
